'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.TooltipItem = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactBootstrap = require('react-bootstrap');

var _reactIntl = require('react-intl');

var _axwayReactIntl = require('axway-react-intl');

var _axwayReactIntl2 = _interopRequireDefault(_axwayReactIntl);

var _Badge = require('./Badge');

var _Badge2 = _interopRequireDefault(_Badge);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * Wraps a JSX element in an overlay giving it a tooltip on hover
 * Tooltip will only be displayed if rendered inside a collapsed nav
 */
var TooltipItem = exports.TooltipItem = function TooltipItem(_ref, _ref2) {
	var tooltip = _ref.tooltip,
	    children = _ref.children;
	var collapsed = _ref2.collapsed;

	var overlay = _react2.default.createElement(
		_reactBootstrap.Tooltip,
		{ id: 'tooltip', className: (0, _classnames2.default)({ hidden: !tooltip || !collapsed }) },
		tooltip
	);
	return _react2.default.createElement(
		_reactBootstrap.OverlayTrigger,
		{
			shouldUpdatePosition: true,
			placement: 'right',
			overlay: overlay
		},
		children
	);
};

TooltipItem.contextTypes = {
	collapsed: _propTypes2.default.bool
};

TooltipItem.propTypes = {
	tooltip: _propTypes2.default.string
};

/**
 * Hint: To prevent the navigation menu scrolling,
 * make sure to set a min-height on your application container
 */

var NavigationMenu = function (_React$Component) {
	_inherits(NavigationMenu, _React$Component);

	function NavigationMenu(props) {
		_classCallCheck(this, NavigationMenu);

		var _this = _possibleConstructorReturn(this, (NavigationMenu.__proto__ || Object.getPrototypeOf(NavigationMenu)).call(this, props));

		_this.onToggle = _this.onToggle.bind(_this);
		_this.renderResizeToggle = _this.renderResizeToggle.bind(_this);
		return _this;
	}

	_createClass(NavigationMenu, [{
		key: 'getChildContext',
		value: function getChildContext() {
			var _props = this.props,
			    collapsed = _props.collapsed,
			    type = _props.type;

			return {
				collapsed: collapsed,
				isPrimary: type === 'primary'
			};
		}
	}, {
		key: 'onToggle',
		value: function onToggle() {
			var _props2 = this.props,
			    collapsed = _props2.collapsed,
			    onToggle = _props2.onToggle;

			onToggle && onToggle(!collapsed);
		}
	}, {
		key: 'renderResizeToggle',
		value: function renderResizeToggle() {
			var _props3 = this.props,
			    collapsed = _props3.collapsed,
			    collapsible = _props3.collapsible;

			return _react2.default.createElement(
				'div',
				{ className: 'nav-toggle' },
				collapsible && _react2.default.createElement(
					'button',
					{ className: (0, _classnames2.default)({ collapsed: collapsed }), onClick: this.onToggle },
					_react2.default.createElement('span', { className: 'gg icon-GG-chevron-left' })
				)
			);
		}
	}, {
		key: 'render',
		value: function render() {
			var _props4 = this.props,
			    collapsed = _props4.collapsed,
			    children = _props4.children,
			    type = _props4.type,
			    header = _props4.header,
			    className = _props4.className;

			var isPrimary = type === 'primary';
			var ariaExpanded = collapsed ? 'false' : 'true';
			return _react2.default.createElement(
				'div',
				{
					className: (0, _classnames2.default)('axui', 'nav-menu', type, className),
					'aria-expanded': isPrimary ? ariaExpanded : undefined
				},
				_react2.default.createElement(
					'nav',
					{ className: (0, _classnames2.default)({ collapsed: isPrimary && collapsed }) },
					!isPrimary && header && _react2.default.createElement(
						'div',
						{ className: 'nav-header' },
						header
					),
					children,
					isPrimary && this.renderResizeToggle()
				)
			);
		}
	}]);

	return NavigationMenu;
}(_react2.default.Component);

NavigationMenu.defaultProps = {
	type: 'primary',
	collapsed: false,
	collapsible: true
};

NavigationMenu.childContextTypes = {
	collapsed: _propTypes2.default.bool,
	isPrimary: _propTypes2.default.bool
};

NavigationMenu.propTypes = {
	className: _propTypes2.default.string,
	// Enables or disables the collapse toggle button on the nav.
	// Only valid when type is 'primary'
	collapsible: _propTypes2.default.bool,
	// Renders the nav collapsed.
	// Only valid when type is 'primary'
	collapsed: _propTypes2.default.bool,
	// Secondary navigation header.
	// Only valid when type is 'secondary'
	header: _propTypes2.default.string,
	// Callback function for when the nav collapsed state is toggled
	// Only valid when type is 'primary'
	onToggle: _propTypes2.default.func,
	// Style of navigation to render
	type: _propTypes2.default.oneOf(['primary', 'secondary'])
};

NavigationMenu.Links = function (_ref3, _ref4) {
	var children = _ref3.children;
	var collapsed = _ref4.collapsed;

	// If nav is collapsed we want to wrap each nav item in an overlay trigger

	var wrappedChildren = void 0;
	if (collapsed) {
		wrappedChildren = _react2.default.Children.map(children, function (child) {
			var innerChildren = child.props && child.props.children;
			var tooltip = innerChildren;
			if (!innerChildren) {
				tooltip = child;
			} else {
				// If there are multiple sub-children just render the second
				// as a tooltip - The first is going to be an icon
				var cArr = _react2.default.Children.toArray(innerChildren);
				if (cArr.length > 1) {
					tooltip = cArr[1];
				}
			}
			return _react2.default.createElement(
				TooltipItem,
				{ tooltip: tooltip },
				child
			);
		});
	}
	return _react2.default.createElement(
		'div',
		{ className: 'nav-links', role: 'menu' },
		wrappedChildren || children
	);
};

NavigationMenu.Links.contextTypes = {
	collapsed: _propTypes2.default.bool
};

var ProductInfo = function (_React$Component2) {
	_inherits(ProductInfo, _React$Component2);

	function ProductInfo(props) {
		_classCallCheck(this, ProductInfo);

		var _this2 = _possibleConstructorReturn(this, (ProductInfo.__proto__ || Object.getPrototypeOf(ProductInfo)).call(this, props));

		_axwayReactIntl2.default.init(_this2);
		_this2.docText = _this2.intl.formatMsg('View documentation');
		_this2.renderDocs = _this2.renderDocs.bind(_this2);
		_this2.renderText = _this2.renderText.bind(_this2);
		return _this2;
	}

	_createClass(ProductInfo, [{
		key: 'renderText',
		value: function renderText() {
			var collapsed = this.context.collapsed;
			var _props5 = this.props,
			    text = _props5.text,
			    collapsedText = _props5.collapsedText;

			if (!text) {
				return null;
			}
			return _react2.default.createElement(
				TooltipItem,
				{ tooltip: text },
				_react2.default.createElement(
					'span',
					{ className: (0, _classnames2.default)('nav-text', { collapsed: collapsed }) },
					collapsed ? collapsedText || text : text
				)
			);
		}
	}, {
		key: 'renderDocs',
		value: function renderDocs() {
			var collapsed = this.context.collapsed;
			var docLink = this.props.docLink;

			if (!docLink) {
				return null;
			}
			return _react2.default.createElement(
				TooltipItem,
				{ tooltip: this.docText },
				_react2.default.createElement(
					'a',
					{
						href: docLink,
						className: (0, _classnames2.default)('nav-docs', { collapsed: collapsed }),
						target: '_blank',
						rel: 'noopener noreferrer'
					},
					_react2.default.createElement('span', { className: 'gg icon-GG-lifebuoy' }),
					_react2.default.createElement(
						'span',
						{ className: 'doc-text' },
						this.docText
					),
					_react2.default.createElement('span', { className: 'gg icon-GG-chevron-right' })
				)
			);
		}
	}, {
		key: 'render',
		value: function render() {
			return _react2.default.createElement(
				'div',
				{ className: 'nav-footer' },
				this.renderText(),
				this.renderDocs()
			);
		}
	}]);

	return ProductInfo;
}(_react2.default.Component);

ProductInfo.propTypes = {
	/* link to product documentation */
	docLink: _propTypes2.default.string,
	/* Product text */
	text: _propTypes2.default.string,
	/* Product text to render when nav is collapsed */
	collapsedText: _propTypes2.default.string
};

ProductInfo.contextTypes = {
	collapsed: _propTypes2.default.bool
};

NavigationMenu.ProductInfo = (0, _reactIntl.injectIntl)(ProductInfo);

NavigationMenu.NotificationBadge = function (_ref5) {
	var bsStyle = _ref5.bsStyle,
	    notifications = _ref5.notifications;

	if (!notifications) {
		return null;
	}
	var notificationText = void 0;
	var notificationClass = void 0;
	if (typeof notifications === 'number') {
		notificationText = Math.min(notifications, 99);
		notificationClass = notifications > 9 ? 'two-digits' : undefined;
	}
	return _react2.default.createElement(
		'div',
		{ className: 'nav-badge' },
		_react2.default.createElement(
			_Badge2.default,
			{ bsStyle: bsStyle, className: notificationClass },
			notificationText
		)
	);
};

NavigationMenu.NotificationBadge.propTypes = {
	/**
  * Controls the notification status
  * PropTypes.number: the notification count to display.
  * PropTypes.bool: the notifications
  */
	notifications: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.bool]),
	/* Badge colour */
	bsStyle: _propTypes2.default.oneOf(['success', 'info', 'warning', 'danger'])
};

NavigationMenu.NotificationBadge.defaultProps = {
	notifications: false,
	bsStyle: 'danger'
};

NavigationMenu.Link = function (_ref6, _ref7) {
	var isPrimary = _ref7.isPrimary;

	var active = _ref6.active,
	    icon = _ref6.icon,
	    children = _ref6.children,
	    className = _ref6.className,
	    notifications = _ref6.notifications,
	    notificationStyle = _ref6.notificationStyle,
	    props = _objectWithoutProperties(_ref6, ['active', 'icon', 'children', 'className', 'notifications', 'notificationStyle']);

	return _react2.default.createElement(
		'a',
		_extends({
			'aria-current': active ? 'page' : undefined,
			role: 'menuitem',
			className: (0, _classnames2.default)('nav-link', { active: active }, className)
		}, props),
		isPrimary && icon && _react2.default.createElement('span', { className: 'gg icon-GG-' + icon }),
		children,
		_react2.default.createElement(NavigationMenu.NotificationBadge, {
			notifications: notifications,
			bsStyle: notificationStyle
		})
	);
};

NavigationMenu.Link.contextTypes = {
	isPrimary: _propTypes2.default.bool
};

NavigationMenu.Link.propTypes = {
	/* Link target */
	href: _propTypes2.default.string,
	/* Should the link render as active? */
	active: _propTypes2.default.bool.isRequired,
	/* className to apply to link */
	className: _propTypes2.default.string,
	/* icon class to render e.g. `bug`. Only rendered for primary navs */
	icon: _propTypes2.default.string,
	/**
  * Controls the notification status of the link
  * PropTypes.number: the notification count to display.
  * PropTypes.bool: the notifications
  */
	notifications: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.bool]),
	/* Badge colour */
	notificationStyle: _propTypes2.default.oneOf(['success', 'info', 'warning', 'danger'])
};

var _default = NavigationMenu;
exports.default = _default;
;

var _temp = function () {
	if (typeof __REACT_HOT_LOADER__ === 'undefined') {
		return;
	}

	__REACT_HOT_LOADER__.register(TooltipItem, 'TooltipItem', 'src/components/NavigationMenu.jsx');

	__REACT_HOT_LOADER__.register(NavigationMenu, 'NavigationMenu', 'src/components/NavigationMenu.jsx');

	__REACT_HOT_LOADER__.register(ProductInfo, 'ProductInfo', 'src/components/NavigationMenu.jsx');

	__REACT_HOT_LOADER__.register(_default, 'default', 'src/components/NavigationMenu.jsx');
}();

;